(function () {
  const SVG_NS = 'http://www.w3.org/2000/svg';
  const CX = 210;
  const CY = 210;

  const ICONS = {
    eye: '<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><path d="M12 12m-3 0a3 3 0 1 0 6 0 3 3 0 1 0-6 0"></path>',
    leaf: '<path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"></path><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"></path>',
    shield:
      '<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>',
    droplet: '<path d="M12 2.69s-5.5 5.4-5.5 9.5a5.5 5.5 0 0 0 11 0c0-4.1-5.5-9.5-5.5-9.5z"></path>',
    waves: '<path d="M2 15c6.667-6 13.333 0 20-6"></path><path d="M2 9c6.667 6 13.333 0 20 6"></path><path d="M9 4h6"></path><path d="M9 20h6"></path><path d="M9 12h6"></path>',
    star: '<path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>',
    scan: '<path d="M12 12m-8 0a8 8 0 1 0 16 0 8 8 0 1 0-16 0"></path><path d="M12 12m-2 0a2 2 0 1 0 4 0 2 2 0 1 0-4 0"></path><path d="M12 2v2"></path><path d="M12 20v2"></path><path d="M2 12h2"></path><path d="M20 12h2"></path>',
    dna: '<path d="M2 15c6.667-6 13.333 0 20-6"></path><path d="M2 9c6.667 6 13.333 0 20 6"></path>',
  };

  function svgEl(name, attrs) {
    const node = document.createElementNS(SVG_NS, name);
    Object.keys(attrs || {}).forEach((key) => {
      const value = attrs[key];
      if (value === undefined || value === null) return;
      node.setAttribute(key, String(value));
    });
    return node;
  }

  function polar(radius, angle) {
    return {
      x: CX + radius * Math.cos(angle),
      y: CY + radius * Math.sin(angle),
    };
  }

  function pointsAttr(points) {
    return points.map((point) => `${point.x},${point.y}`).join(' ');
  }

  function hexWithAlpha(color, alphaHex) {
    if (!color) return color;
    const hex = color.trim();
    if (/^#[0-9a-fA-F]{6}$/.test(hex)) return `${hex}${alphaHex}`;
    return hex;
  }

  function readIngredients(listItems) {
    return listItems.map((el) => ({
      name: el.dataset.name || '',
      dose: el.dataset.dose || '',
      color: el.dataset.color || '#ffffff',
      potency: Number(el.dataset.potency) || 98,
    }));
  }

  function geometry(items) {
    const count = items.length;
    const radius = count > 5 ? 155 : 140;
    const labelScale = count > 5 ? 1.32 : 1.22;
    const angles = items.map((_, index) => (Math.PI * 2 * index) / count - Math.PI / 2);
    const gridLevels = [0.25, 0.5, 0.75, 1].map((level) =>
      angles.map((angle) => polar(radius * level, angle))
    );
    const dataPoints = angles.map((angle, index) =>
      polar(radius * ((items[index].potency || 98) / 100), angle)
    );
    const labelPositions = angles.map((angle) => polar(radius * labelScale, angle));
    const axisEndpoints = angles.map((angle) => polar(radius, angle));

    return { count, radius, gridLevels, dataPoints, labelPositions, axisEndpoints };
  }

  function buildChart(svg, items, options) {
    const { light, uid } = options;
    const geo = geometry(items);
    const dense = geo.count > 5;

    const defs = svgEl('defs');
    items.forEach((item, index) => {
      const next = items[(index + 1) % items.length];
      const gradient = svgEl('linearGradient', {
        id: `wl-radar-seg-${uid}-${index}`,
        x1: '0',
        y1: '0',
        x2: '0',
        y2: '1',
      });
      gradient.appendChild(
        svgEl('stop', { offset: '0%', 'stop-color': item.color, 'stop-opacity': '0.35' })
      );
      gradient.appendChild(
        svgEl('stop', { offset: '100%', 'stop-color': next.color, 'stop-opacity': '0.1' })
      );
      defs.appendChild(gradient);
    });

    const filter = svgEl('filter', { id: `wl-radar-glow-${uid}` });
    filter.appendChild(svgEl('feGaussianBlur', { stdDeviation: '3', result: 'blur' }));
    const merge = svgEl('feMerge');
    merge.appendChild(svgEl('feMergeNode', { in: 'blur' }));
    merge.appendChild(svgEl('feMergeNode', { in: 'SourceGraphic' }));
    filter.appendChild(merge);
    defs.appendChild(filter);
    svg.appendChild(defs);

    geo.gridLevels.forEach((levelPoints) => {
      svg.appendChild(
        svgEl('polygon', {
          points: pointsAttr(levelPoints),
          fill: 'none',
          stroke: 'rgba(255,255,255,0.06)',
          'stroke-width': '0.8',
        })
      );
    });

    geo.axisEndpoints.forEach((point) => {
      svg.appendChild(
        svgEl('line', {
          x1: String(CX),
          y1: String(CY),
          x2: String(point.x),
          y2: String(point.y),
          stroke: 'rgba(255,255,255,0.08)',
          'stroke-width': '0.5',
        })
      );
    });

    geo.dataPoints.forEach((point, index) => {
      const next = geo.dataPoints[(index + 1) % geo.dataPoints.length];
      const segment = svgEl('polygon', {
        points: `${CX},${CY} ${point.x},${point.y} ${next.x},${next.y}`,
        fill: `url(#wl-radar-seg-${uid}-${index})`,
        class: 'wl-radar__segment',
        'data-radar-segment': 'true',
        'data-index': String(index),
      });
      segment.style.transitionDelay = `${0.3 + index * 0.08}s`;
      svg.appendChild(segment);
    });

    const outline = svgEl('polygon', {
      points: pointsAttr(geo.dataPoints),
      fill: 'none',
      stroke: 'rgba(255,255,255,0.4)',
      'stroke-width': '1.5',
      filter: `url(#wl-radar-glow-${uid})`,
      class: 'wl-radar__data-outline',
    });
    outline.style.transitionDelay = '0.5s';
    svg.appendChild(outline);

    geo.dataPoints.forEach((point, index) => {
      const item = items[index];
      const isActive = index === 0;
      const group = svgEl('g', {
        class: `wl-radar__dot-group${isActive ? ' is-active' : ''}`,
        'data-radar-dot': 'true',
        'data-index': String(index),
        'data-color': item.color,
        tabindex: '0',
        role: 'button',
        'aria-label': item.name,
      });
      group.appendChild(
        svgEl('circle', {
          cx: String(point.x),
          cy: String(point.y),
          r: '22',
          fill: 'transparent',
          class: 'wl-radar__dot-hit',
        })
      );
      group.appendChild(
        svgEl('circle', {
          cx: String(point.x),
          cy: String(point.y),
          r: '14',
          fill: hexWithAlpha(item.color, '40'),
          class: 'wl-radar__dot-ring',
        })
      );
      group.appendChild(
        svgEl('circle', {
          cx: String(point.x),
          cy: String(point.y),
          r: isActive ? '8' : '5.5',
          fill: isActive ? item.color : light,
          stroke: item.color,
          'stroke-width': isActive ? '2.5' : '1.5',
          class: 'wl-radar__dot-core',
          'data-radar-dot-core': 'true',
        })
      );
      svg.appendChild(group);
    });

    geo.labelPositions.forEach((point, index) => {
      const item = items[index];
      const isActive = index === 0;
      const group = svgEl('g', {
        transform: `translate(${point.x}, ${point.y})`,
        class: `wl-radar__label${isActive ? ' is-active' : ''}${dense ? ' wl-radar__label--dense' : ''}`,
        'data-radar-label': 'true',
        'data-index': String(index),
        'data-color': item.color,
      });
      const name = svgEl('text', {
        x: '0',
        y: '-6',
        'text-anchor': 'middle',
        class: 'wl-radar__label-name',
      });
      name.textContent = item.name;
      const dose = svgEl('text', {
        x: '0',
        y: '8',
        'text-anchor': 'middle',
        class: 'wl-radar__label-dose',
        'data-radar-label-dose': 'true',
      });
      dose.textContent = item.dose;
      if (isActive) dose.style.fill = item.color;
      group.appendChild(name);
      group.appendChild(dose);
      svg.appendChild(group);
    });
  }

  function initRadar(root) {
    if (!root || root.dataset.radarReady === 'true') return;
    root.dataset.radarReady = 'true';

    const listItems = Array.from(root.querySelectorAll('[data-radar-list-item]'));
    const detail = root.querySelector('[data-radar-detail]');
    const svg = root.querySelector('[data-radar-svg]');
    const light = root.dataset.radarLight || '#838bc4';
    const uid = root.dataset.radarId || 'radar';
    const items = readIngredients(listItems);

    if (svg && items.length) {
      while (svg.firstChild) svg.removeChild(svg.firstChild);
      buildChart(svg, items, { light, uid });
    }

    function select(index) {
      const item = listItems.find((el) => el.dataset.index === String(index));
      if (!item) return;

      listItems.forEach((el) => {
        const isActive = el === item;
        el.classList.toggle('is-active', isActive);

        const dose = el.querySelector('.wl-radar__list-dose');
        if (dose) {
          dose.style.color = isActive ? el.dataset.color : '';
        }

        const fill = el.querySelector('.wl-radar__list-bar-fill');
        if (fill) {
          fill.style.width = isActive ? `${el.dataset.potency}%` : '0%';
        }
      });

      root.querySelectorAll('[data-radar-dot]').forEach((el) => {
        const isActive = el.dataset.index === String(index);
        el.classList.toggle('is-active', isActive);
        const core = el.querySelector('[data-radar-dot-core], .wl-radar__dot-core');
        if (!core) return;
        const color = el.dataset.color;
        core.setAttribute('r', isActive ? '8' : '5.5');
        core.setAttribute('fill', isActive ? color : light);
        core.setAttribute('stroke-width', isActive ? '2.5' : '1.5');
      });

      root.querySelectorAll('[data-radar-label]').forEach((el) => {
        const isActive = el.dataset.index === String(index);
        el.classList.toggle('is-active', isActive);
        const dose = el.querySelector('[data-radar-label-dose], .wl-radar__label-dose');
        if (dose) {
          dose.style.fill = isActive ? el.dataset.color : 'rgba(255,255,255,0.3)';
        }
      });

      if (!detail) return;

      const iconWrap = detail.querySelector('[data-radar-detail-icon]');
      if (iconWrap) {
        if (item.dataset.customIcon) {
          iconWrap.innerHTML = item.dataset.customIcon;
        } else {
          iconWrap.innerHTML = `<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="${item.dataset.color}" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${
            ICONS[item.dataset.icon] || ICONS.eye
          }</svg>`;
        }
      }

      const name = detail.querySelector('[data-radar-detail-name]');
      if (name) name.textContent = item.dataset.name;

      const dose = detail.querySelector('[data-radar-detail-dose]');
      if (dose) dose.textContent = item.dataset.dose;

      const short = detail.querySelector('[data-radar-detail-short]');
      if (short) short.textContent = item.dataset.descriptionShort;

      const long = detail.querySelector('[data-radar-detail-long]');
      if (long) long.textContent = item.dataset.descriptionLong;

      const comparisonLabel = detail.querySelector('[data-radar-detail-comparison-label]');
      if (comparisonLabel) {
        comparisonLabel.textContent = item.dataset.comparisonLabel;
      }

      const bar = detail.querySelector('[data-radar-detail-bar]');
      if (bar) {
        bar.style.width = `${item.dataset.potency}%`;
        bar.style.background = item.dataset.color;
      }
    }

    root.addEventListener('click', (event) => {
      const listItem = event.target.closest('[data-radar-list-item]');
      if (listItem && root.contains(listItem)) {
        select(listItem.dataset.index);
        return;
      }

      const hit = event.target.closest('[data-radar-dot], [data-radar-label], [data-radar-segment]');
      if (hit && root.contains(hit)) {
        select(hit.getAttribute('data-index'));
      }
    });

    root.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const hit = event.target.closest('[data-radar-dot], [data-radar-list-item]');
      if (!hit || !root.contains(hit)) return;
      event.preventDefault();
      select(hit.dataset.index || hit.getAttribute('data-index'));
    });

    root.classList.add('is-visible');
  }

  function initAll() {
    document.querySelectorAll('.wl-radar').forEach(initRadar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector
      ? event.target.querySelector('.wl-radar')
      : null;
    if (root) initRadar(root);
  });
})();
